import { authAxiosClient } from '@/lib';
import { omit, withLogger } from '@/utils';

import { usersAPIUrls } from '../data';
import { Nullable } from '@/types';

type Param = {
  userId: Nullable<string>;
  firstName: string;
  lastName: string;
  email: string;
};

type Return = boolean;

export const updateUser = withLogger(async (props: Param): Promise<Return> => {
  const url = `${usersAPIUrls.update}/${props.userId}`;

  await authAxiosClient.patch(url, omit(props, ['userId']));

  return true;
});
